module.exports = __webpack_public_path__ + "img/facebook.424cc1d8.svg";